import {ANALYTICS_ENABLED} from '../../configs/vars';
import {AddAnalyticEventDocument, AnalyticEventType} from '../../graphql-types';
import graphQLClient from '../graphql/client';
import getPageviewValue from './getPageviewValue';

let logPageviewTimeout: NodeJS.Timeout | undefined;

const logPageview = (pathname: string) => {
    clearTimeout(logPageviewTimeout);

    if (!ANALYTICS_ENABLED || !localStorage?.accountState) {
        return;
    }

    logPageviewTimeout = setTimeout(() => {
        try {
            const pageviewValue = getPageviewValue(pathname);
            const analyticsData = {
                type: AnalyticEventType.Pageview,
                value: pageviewValue,
                pageUrl: pathname,
            };

            graphQLClient.mutate({
                mutation: AddAnalyticEventDocument,
                variables: {
                    input: analyticsData,
                },
            }).then(() => { }).catch(() => { });
        } catch (e) {}
    }, 2000);
};

export default logPageview;
